import InstitutionalView from "./InstitutionalView";
export default InstitutionalView;
